import { debug } from "./debug";

const isValid = (value: string | null): value is string => ![null, undefined, ""].includes(value);

const getStorageItem = <T>({key,defaultValue,}: { key: string; defaultValue: T;}): T => {
    const { [key]: value }: Storage = window
        ? localStorage
        : ({ [key]: undefined } as unknown as Storage);

    if (!isValid(value)) {
        return defaultValue;
    }

    return JSON.parse(value);
};

const setStorageItem = <T>({key,value,}: { key: string; value: T;}) => {
    debug(key, value)
    if (window) {
        localStorage.setItem(key, JSON.stringify(value))
    }
};

export { getStorageItem, setStorageItem }